import "./App.css";
import { v4 as uuidv4 } from "uuid";
import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Header from "./components/Header/Header";
import Home from "./components/Home/Home";
import { Box } from "@mui/system";
import {
  getQuestions,
  getQuizparts,
  getSubtopics,
} from "./fetching/fetchingQuizze";
import {
  fetchBubbles,
  fetchCharacterFrames,
  fetchCharacters,
  fetchCharacterStories,
  fetchChoices,
  fetchFrames,
  fetchStories,
} from "./fetching/fetchingCharacter";
import { getVideos } from "./fetching/fetchingVideo";
import Question from "./components/Learning/Question/Question";
import {
  getQuizProgress,
  getStoryProgress,
} from "./fetching/fetchingUser";
import QuizzeOverview from "./components/Learning/QuizzeOverview";
import Questions from "./components/Learning/Questions";
import FinishedQuiz from "./components/Learning/FinishedQuiz";
import { checkToken } from "./utils/tokenHandler";
import {
  fetchProgress,
  handleQuizProgress,
  handleStoryProgress,
} from "./utils/UserProgressHandling";
import Intro from "./components/InteractiveStory/Intro";
import Videos from "./components/Videos/Videos";
import Statistics from "./components/Statistics/Statistics";
import Impressum from "./components/Affiliate/Impressum";
import Privacy from "./components/Affiliate/Privacy";
import Story from "./components/InteractiveStory/Story";
import Frame from "./components/InteractiveStory/Frame";
import FinishedFrame from "./components/InteractiveStory/FinishedFrame";
import WelcomeSurvey from "./components/Survey/WelcomeSurvey";
import SimpleSurvey from "./components/Survey/SimpleSurvey";
import SurveyFinish from "./components/Survey/SurveyFinish";
import { sendSurveyData } from "./fetching/fetchingSurvey";
import Survey from "./components/Survey/Survey";
import Materials from "./components/Materials/Materials";
import { videoQuestions } from "./data/videoQuestions";
import Publications from "./components/Publications/Publications";

function App() {
  const localSurveyData = localStorage.getItem("localSurveyData");
  const localSurveyUser = localStorage.getItem("localSurveyUser");
  const localSurveyFinished = localStorage.getItem("localSurveyFinished");
  const localSurveyStarted = localStorage.getItem("localSurveyStarted");
  const localSurveyStartedTime = localStorage.getItem("localSurveyStartedTime");
  const localActiveSurveyPart = localStorage.getItem("localActiveSurveyPart");
  const localSurveyChangeBehaviour = localStorage.getItem(
    "localSurveyChangeBehaviour"
  );
  const localSurveyMailShared = localStorage.getItem("localSurveyMailShared");

  const localAnonUserId = localStorage.getItem("localAnonUserId");
  const localUsage = localStorage.getItem("localUsage");

  const [credentials, setCredentials] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [token, setToken] = useState(null);
  const anonUserId = localAnonUserId ? JSON.parse(localAnonUserId) : uuidv4();
  if (!localAnonUserId) {
    localStorage.setItem("localAnonUserId", JSON.stringify(anonUserId));
  }

  const [surveyUserData, setSurveyUserData] = useState(
    localSurveyData ? JSON.parse(localSurveyData) : []
  );
  const surveyUser = localSurveyUser ? JSON.parse(localSurveyUser) : uuidv4();
  if (!localSurveyUser) {
    localStorage.setItem("localSurveyUser", JSON.stringify(surveyUser));
  }
  const [surveyFinished, setSurveyFinished] = useState(
    localSurveyFinished ? JSON.parse(localSurveyFinished) : false
  );
  const [surveyStarted, setSurveyStarted] = useState(
    localSurveyStarted ? JSON.parse(localSurveyStarted) : false
  );
  const [surveyStartedTime, setSurveyStartedTime] = useState(
    localSurveyStartedTime ? new Date(JSON.parse(localSurveyStartedTime)) : null
  );
  const [activeSurveyPart, setActiveSurveyPart] = useState(
    localActiveSurveyPart ? parseInt(JSON.parse(localActiveSurveyPart)) : 0
  );
  const [surveyChangeBehaviour, setSurveyChangeBehaviour] = useState(
    localSurveyChangeBehaviour ? JSON.parse(localSurveyChangeBehaviour) : []
  );
  const [surveyMailShared, setSurveyMailShared] = useState(
    localSurveyMailShared ? JSON.parse(localSurveyMailShared) : false
  );

  const [characters, setCharacters] = useState([]);
  const [stories, setStories] = useState([]);
  const [characterStories, setCharacterStories] = useState([]);
  const [frames, setFrames] = useState([]);
  const [bubbles, setBubbles] = useState([]);
  const [choices, setChoices] = useState([]);
  const [frameChars, setFrameChars] = useState([]);

  const [usage, setUsage] = useState(
    localUsage
      ? JSON.parse(localUsage)
      : {
          seenStoryHint: false,
          seenQuizHint: false,
          seenVideoHint: false,
          seenSwipeHint: false,
          seenEventHint: false,
        }
  );

  const [quizparts, setQuizparts] = useState([]);
  const [subtopics, setSubtopics] = useState([]);
  const [questions, setQuestions] = useState([]);

  const [videos, setVideos] = useState([]);

  const [quizProgress, setQuizProgress] = useState([]);
  const [videosWatched, setVideosWatched] = useState(localStorage.getItem("videosWatched") ? JSON.parse(localStorage.getItem("videosWatched")) : []);
  const [storyProgress, setStoryProgress] = useState([]);

  const updateVideoFinished = (videoId) => {
    const finishedVideos = [...videosWatched, videoId]
    setVideosWatched(finishedVideos)
    localStorage.setItem("videosWatched", JSON.stringify(finishedVideos));
  }
  
  const updateSurveyData = (questionId, answer, text) => {
    const index = surveyUserData.findIndex(
      (el) => el.questionId === questionId
    );
    if (index !== -1) {
      const dummy_state = [...surveyUserData];
      dummy_state[index] = {
        questionId: questionId,
        answer: answer,
        text: text,
      };
      setSurveyUserData(dummy_state);
    } else {
      setSurveyUserData([
        ...surveyUserData,
        { questionId: questionId, answer: answer, text: text },
      ]);
    }
  };

  const updateChangeBehaviour = (questionId, oldAnswer, newAnswer) => {
    setSurveyChangeBehaviour([
      ...surveyChangeBehaviour,
      {
        questionId: questionId,
        oldAnswer: oldAnswer,
        newAnswer: newAnswer,
        timestamp: Date.now(),
      },
    ]);
  };

  const finishSurvey = (changeAllowed, timeAllowed, lang) => {
    const changeData = changeAllowed ? surveyChangeBehaviour : "not allowed";
    const time = timeAllowed ? surveyStartedTime : "not allowed";
    sendSurveyData(surveyUser, surveyUserData, changeData, time, lang);
    setSurveyUserData([]);
    setSurveyFinished(true);
  };

  const startSurvey = () => {
    if (!surveyStarted) {
      setSurveyStarted(true);
      setSurveyStartedTime(Date.now());
    }
  };

  useEffect(() => {
    localStorage.setItem("localSurveyData", JSON.stringify(surveyUserData));
  }, [surveyUserData]);

  useEffect(() => {
    localStorage.setItem("localSurveyFinished", JSON.stringify(surveyFinished));
  }, [surveyFinished]);

  useEffect(() => {
    localStorage.setItem("localSurveyStarted", JSON.stringify(surveyStarted));
  }, [surveyStarted]);

  useEffect(() => {
    localStorage.setItem(
      "localSurveyStartedTime",
      JSON.stringify(surveyStartedTime)
    );
  }, [surveyStartedTime]);

  useEffect(() => {
    localStorage.setItem(
      "localActiveSurveyPart",
      JSON.stringify(activeSurveyPart)
    );
  }, [activeSurveyPart]);

  useEffect(() => {
    localStorage.setItem(
      "localSurveyChangeBehaviour",
      JSON.stringify(surveyChangeBehaviour)
    );
  }, [surveyChangeBehaviour]);

  useEffect(() => {
    localStorage.setItem(
      "localSurveyMailShared",
      JSON.stringify(surveyMailShared)
    );
  }, [surveyMailShared]);

  useEffect(() => {
    checkToken(setToken, setIsLoggedIn, setCredentials);
  }, []);

  useEffect(() => {
    localStorage.setItem("localUsage", JSON.stringify(usage));
  }, [usage]);

  useEffect(() => {
    fetchProgress(
      token,
      setQuizProgress,
      isLoggedIn,
      "localQuizProgress",
      getQuizProgress
    );
  }, [token, isLoggedIn]);

  useEffect(() => {
    fetchProgress(
      token,
      setStoryProgress,
      isLoggedIn,
      "localStoryProgress",
      getStoryProgress
    );
  }, [token, isLoggedIn]);

  useEffect(() => {
    fetchCharacters().then((result) => {
      setCharacters(result);
    });
  }, []);

  useEffect(() => {
    fetchStories().then((result) => {
      setStories(result);
    });
  }, []);

  useEffect(() => {
    getQuizparts().then((result) => {
      setQuizparts(result);
    });
  }, []);

  useEffect(() => {
    getSubtopics().then((result) => {
      setSubtopics(result);
    });
  }, []);

  useEffect(() => {
    getQuestions().then((result) => {
      setQuestions(result);
    });
  }, []);

  useEffect(() => {
    getVideos().then((result) => {
      setVideos(result);
    });
  }, []);

  useEffect(() => {
    getQuizProgress(anonUserId)
      .then((result) => {
        setQuizProgress(result);
      })
      .catch((error) => {
        const localQuizProgress = localStorage.getItem("localQuizProgress");
        if (localQuizProgress) {
          setQuizProgress(JSON.parse(localQuizProgress));
        }
      });
  }, []);

  useEffect(() => {
    getStoryProgress()
      .then((result) => {
        setStoryProgress(result);
      })
      .catch((error) => {
        const localStoryProgress = localStorage.getItem("localStoryProgress");
        if (localStoryProgress) {
          setStoryProgress(JSON.parse(localStoryProgress));
        }
      });
  }, []);

  useEffect(() => {
    fetchCharacterFrames().then((result) => {
      setFrameChars(result);
    });
  }, []);

  useEffect(() => {
    fetchBubbles().then((result) => {
      setBubbles(result);
    });
  }, []);

  useEffect(() => {
    fetchChoices().then((result) => {
      setChoices(result);
    });
  }, []);

  useEffect(() => {
    fetchFrames().then((result) => {
      setFrames(result);
    });
  }, []);

  useEffect(() => {
    fetchCharacterStories().then((result) => {
      setCharacterStories(result);
    });
  }, []);

  const updateQuizProgress = (subtopicId) => {
    handleQuizProgress(
      subtopicId,
      token,
      quizProgress,
      setQuizProgress,
      isLoggedIn,
      anonUserId
    );
  };

  const updateStoryProgress = (
    substoryId,
    relevant,
    identifier,
    bestAnswer
  ) => {
    handleStoryProgress(
      substoryId,
      token,
      storyProgress,
      setStoryProgress,
      isLoggedIn,
      relevant,
      identifier,
      bestAnswer
    );
  };

  const updateUsage = (type) => {
    switch (type) {
      case "storyHintSeen":
        setUsage({ ...usage, seenStoryHint: true });
        break;
      case "videoHintSeen":
        setUsage({ ...usage, seenVideoHint: true });
        break;
      case "quizHintSeen":
        setUsage({ ...usage, seenQuizHint: true });
        break;
      case "swipeHintSeen":
        setUsage({ ...usage, seenSwipeHint: true });
        break;
      case "eventHintSeen":
        setUsage({ ...usage, seenEventHint: true });
        break;
      default:
        break;
    }
  };

  const [activeBackgroundImg, setActiveBackgroundImg] = useState(null);

  return (
    <BrowserRouter>
      {/* <BackgroundImageHandler setActiveBackgroundImg={setActiveBackgroundImg} /> */}
      <Box className="App" sx={{ position: "relative" }}>
        <Box
          sx={{
            position: "relative",
            "&:before": {
              content: "' '",
              display: "block",
              position: "absolute",
              left: "0",
              top: "0",
              width: "100%",
              height: "100%",
              minHeight: "100vh",
              backgroundImage: `url(${activeBackgroundImg})`,
              backgroundColor: "#ddd",
              backgroundSize: "cover",
              backgroundAttachment: "fixed",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "50% 0",
              opacity: "0.5",
              zIndex: -1,
              // }
            },
          }}
        >
          <Header />
          <Routes>
            <Route
              path="home"
              element={
                <Home
                  setSwipeHintSeen={() => updateUsage("swipeHintSeen")}
                  setEventHintSeen={() => updateUsage("eventHintSeen")}
                  seenSwipeHint={usage.seenSwipeHint}
                  seenEventHint={usage.seenEventHint}
                />
              }
            />
            <Route
              path="videos"
              element={
                <Videos
                  videosWatched={videosWatched}
                  videos={videos}
                  finishVideo={updateVideoFinished}
                  videoQuestions={videoQuestions}
                  seenVideoHint={usage.seenVideoHint}
                  setVideoHintSeen={() => updateUsage("videoHintSeen")}
                />
              }
            />
            <Route
              path="story"
              element={
                <Intro
                  characters={characters}
                  characterStories={characterStories}
                  storyProgress={storyProgress}
                  seenStoryHint={usage.seenStoryHint}
                  choices={choices}
                  setStoryHintSeen={() => updateUsage("storyHintSeen")}
                />
              }
            />
            <Route
              path="story/:storyId"
              element={
                <Story
                  stories={stories}
                  frames={frames}
                  choices={choices}
                  characters={frameChars}
                  bubbles={bubbles}
                />
              }
            >
              <Route path="finished" element={<FinishedFrame />} />
              <Route
                path=":frameId"
                element={<Frame updateStoryProgress={updateStoryProgress} />}
              />
            </Route>
            <Route
              path={"learning/:quizpartId/:subtopicId/finished"}
              element={
                <FinishedQuiz
                  subtopics={subtopics}
                  questions={questions}
                  quizProgress={quizProgress}
                  quizparts={quizparts}
                />
              }
            />
            <Route
              path={"learning/:quizpartId/:subtopicId"}
              element={
                <Questions subtopics={subtopics} questions={questions} />
              }
            >
              <Route
                path=":activeQuestion"
                element={<Question updateQuizProgress={updateQuizProgress} />}
              />
            </Route>
            <Route
              path="learning"
              element={
                <QuizzeOverview
                  quizparts={quizparts}
                  quizProgress={quizProgress}
                  subtopics={subtopics}
                  seenQuizHint={usage.seenQuizHint}
                  setQuizHintSeen={() => updateUsage("quizHintSeen")}
                />
              }
            />
            <Route
              path="publications"
              element={
                <Publications/>
              }
            />
            <Route
              path="progress"
              element={
                <Statistics
                  subtopics={subtopics}
                  stories={stories}
                  videos={videos}
                  quizProgress={quizProgress}
                  videosWatched={videosWatched}
                  storyProgress={storyProgress}
                  characterStories={characterStories}
                  characters={characters}
                  choices={choices}
                />
              }
            />
            <Route path="impressum" element={<Impressum />} />
            <Route path="privacy" element={<Privacy />} />
            <Route path="materials" element={<Materials />} />
            <Route path="umfrage" element={<Survey />}>
              <Route
                path="start"
                element={<WelcomeSurvey startSurvey={startSurvey} />}
              />
              <Route
                path="standard"
                element={
                  surveyFinished ? (
                    <Navigate to="/umfrage/ende" replace />
                  ) : (
                    <SimpleSurvey
                      updateSurveyData={updateSurveyData}
                      surveyUserData={surveyUserData}
                      finishSurvey={finishSurvey}
                      isFinished={surveyFinished}
                      activePart={activeSurveyPart}
                      setActivePart={setActiveSurveyPart}
                      updateChangeBehaviour={updateChangeBehaviour}
                    />
                  )
                }
              />
              <Route
                path="ende"
                element={
                  <SurveyFinish
                    userId={surveyUser}
                    setMailShared={() => setSurveyMailShared(true)}
                    mailShared={surveyMailShared}
                  />
                }
              />
            </Route>
            <Route
              path=""
              element={
                <Home
                  setSwipeHintSeen={() => updateUsage("swipeHintSeen")}
                  seenSwipeHint={usage.seenSwipeHint}
                />
              }
            />
          </Routes>
        </Box>
      </Box>
    </BrowserRouter>
  );
}

export default App;
